import React, { useEffect, useState, Fragment } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Form, Dimmer, Button } from 'semantic-ui-react'
import { MainBodyContent } from 'components'
import { Cont } from './styled'
import GeneralDetail from './GeneralDetail'
import SelectPrItems from './AddItem'
import Attachment from './Attachment'
import Comment from './Comment'
import Action from './Action'
import { getPrFormData, initializeEditPR, getWorkflowApprover, clearPrFormData } from 'ducks/purchaseRequisition'
import { getGoaItem } from 'ducks/goa'
import Approvers from '../Create/Summary/Approvers'
import ApproversR from '../Details/PRStep/Approvers'
import { validation, validateCase as vCase } from 'core/validate'
import { trackingDetailPath } from 'routes'
import { StatusTag } from '../styled'

const PREdit = (props) => {
  const { valueForm, sn, actions, history, approvers, approverLoading, change } = props
  const { id, status } = valueForm
  const [prId, setPrId] = useState(0)

  useEffect(() => {
    if (valueForm.requesterUser && valueForm.createdByUser &&
        valueForm.companyCode && valueForm.totalAmount) {
      props.getWorkflowApprover(valueForm)
    }
  }, [
    valueForm.requesterUser,
    valueForm.companyCode,
    valueForm.totalAmount,
    valueForm.specialApprovalId
  ])

  useEffect(() => {
    window.scrollTo(0, 0)
    const { match, prId, getPrFormData, initializeEditPR } = props
    initializeEditPR()
    if (match && match.params && match.params.prId) {
      setPrId(match.params.prId)
      if (prId) {
        if (prId !== match.params.prId) {
          getPrFormData(match.params.prId, history)
        }
      } else {
        getPrFormData(match.params.prId, history)
      }
    }
    return (() => {
      props.clearPrFormData({})
    })
  }, [])

  return (
    <MainBodyContent
      headerTitle={
        <Fragment>
          {`Purchase Requisition - Edit ${valueForm.documentNumber ? `#${valueForm.documentNumber}` : ''}`} {<StatusTag marginLeft='1rem' status={status}>{valueForm.statusName}</StatusTag>}
        </Fragment>
      }
      priority={valueForm.priority}
      accessoriesHeaderLeft={showAccessMessage()}
      accessoriesHeader={
        <Fragment>
          {status === 0 ?
            <Approvers loading={approverLoading} approvers={approvers} />
            :
            <ApproversR
              status={status}
              approvers={approvers}
              trigger={
                <Button
                  basic
                  loading={approverLoading}
                  circular
                  type='button'
                  content='View Approver'
                  labelPosition='right'
                  icon='sort numeric down' />}
            />}
          {status !== 0 &&
            <Button
              basic
              circular
              type='button'
              content='Tracking'
              labelPosition='right'
              icon='code branch'
              onClick={() => (window.open(trackingDetailPath(id)))} />}
        </Fragment>
      }
    >
      <Cont>
        <Form>
          <Dimmer.Dimmable as={'div'} dimmed={showAccessDimmer()}>
            <Dimmer simple />
            {id && 
              <Fragment>
                <GeneralDetail history={history} change={change} />
                <SelectPrItems history={history} change={change} />
                <Attachment history={history} change={change} />
              </Fragment>
            }
            {((valueForm.comments || []).length) ? <Comment change={change} /> : null}
            {showAction()}
          </Dimmer.Dimmable>
        </Form>
      </Cont>
    </MainBodyContent>
  )

  function showAction() {
    if (status === 0) {
      let username = localStorage.getItem('username').toLowerCase()
      if (username === (valueForm.createdByUser || '').toLowerCase()) {
        return <Action actions={actions} prId={prId} sn={sn} history={history} />
      }
    } else if (sn && sn.length) {
      return <Action actions={actions} prId={prId} sn={sn} history={history} />
    }
    return null
  }

  function showAccessMessage() {
    if (status === 0) {
      let username = localStorage.getItem('username').toLowerCase()
      if (username === (valueForm.createdByUser || '').toLowerCase()) {
        return null
      } else {
        return <span style={{ color: 'red', fontSize: '1.25rem' }}>You not have permission to access</span>
      }
    } else if (sn && sn.length) {
      return null
    }
    return null
  }

  function showAccessDimmer() {
    if (status === 0) {
      let username = localStorage.getItem('username').toLowerCase()
      if (username === (valueForm.createdByUser || '').toLowerCase()) {
        return false
      }
    } else if (sn && sn.length) {
      return false
    }
    return true
  }
}

const mapStateToProps = (state) => {
  const prFormData = state.pr.prFormData
  const { pr, sn, actions } = prFormData
  return ({
    approvers: state.pr.approvers,
    approverLoading: state.pr.approverLoading,
    sn,
    prId: (pr || {}).id,
    actions,
    initialValues: {
      ...pr
    },
    valueForm: getFormValues('formEditPR')(state) || {},
    goaItemByGoaIdLoading: state.goa.goaItemByGoaIdLoading,
  })
}

const mapDispatchToProps = {
  getPrFormData,
  getGoaItem,
  initializeEditPR,
  getWorkflowApprover,
  clearPrFormData
}

const validate = values => {
  let errors = {}
  errors = validation(values, 'title', [vCase.require, vCase.maxLength200], errors)
  errors = validation(values, 'company', [vCase.require], errors)
  errors = validation(values, 'requester', [vCase.require], errors)
  errors = validation(values, 'documentDate', [vCase.require], errors)

  if (values.special) {
    errors = validation(values, 'specialReason', [vCase.require], errors)

    if ((values.specialReason || '').startsWith('SP') && (values.specialReason || '').length === 4) {
      if (values.specialReason === 'SP04') {
        errors = validation(values, 'subSpecialReason', [vCase.require], errors)
      }

      errors = validation(values, 'vendorCode', [vCase.require], errors)
    } else {
      errors = validation(values, 'specialTitle', [vCase.require], errors)
    }
  }

  if (values.isAdditional) {
    errors = validation(values, 'additionalReason', [vCase.require], errors)
    errors = validation(values, 'referencePoNo', [vCase.require, vCase.maxLength10], errors)
  }

  if (values.isAffiliatedCompanies) {
    errors = validation(values, 'affiliatedCompaniesReason', [vCase.require], errors)
    errors = validation(values, 'vendorCode', [vCase.require], errors)
  }

  if (values.isPartnersPreQualified) {
    errors = validation(values, 'partnersPreQualifiedReason', [vCase.require], errors)
    errors = validation(values, 'vendorCode', [vCase.require], errors)
  }

  if (values.isRent) {
    errors = validation(values, 'rentDays', [vCase.require, vCase.positiveInteger], errors)
  }

  return errors
}

const contForm = reduxForm({
  form: 'formEditPR',
  enableReinitialize: true,
  validate
})(PREdit)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
